/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListKeyWordAction } from '../../models/api-response-list-key-word-action';

export interface ListKeyWordAction$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  refPhoneCompany: string;
  autoActionType: 'OUT_TIME' | 'WAITING_AGENT' | 'NEW_CLIENT' | 'WEEKEND' | 'DAY_OFF' | 'DATE_BIRTH' | 'CATALOG_ORDER' | 'CATALOG_PENDING_ORDER' | 'STATUS_ORDER_UPDATED' | 'PAYMENT_LINK' | 'PAYMENT_WEBSITE' | 'ON_ASSIGN_TICKET' | 'KEY_WORD' | 'EMAIL' | 'CREATE_TICKET' | 'VOUCHER' | 'GMAIL_WEBHOOK' | 'MEDIA_MESSAGE' | 'SPECIAL_BOT' | 'SILENCE_RELAUNCH' | 'RESERVATION_AUTOMATION' | 'CALENDLY_DEMO' | 'TEMPLATE_APPROVED_ALERT';
}

export function listKeyWordAction(http: HttpClient, rootUrl: string, params: ListKeyWordAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListKeyWordAction>> {
  const rb = new RequestBuilder(rootUrl, listKeyWordAction.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('refPhoneCompany', params.refPhoneCompany, {});
    rb.query('autoActionType', params.autoActionType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListKeyWordAction>;
    })
  );
}

listKeyWordAction.PATH = '/v1/api/ui/key-word-action/list/{refPhoneCompany}';
